import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientAppreciationTableAndFilterSchema } from "model/ClientAppreciationModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientAppreciationContext = createContext();

export const ClientAppreciationProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientAppreciationContextData, setClientAppreciationContextData] = useState();

  const fetchClientAppreciationContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientAppreciation", () =>
        fetchClientAppreciationTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientAppreciationContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client appreciation metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientAppreciationContext.Provider
      value={{
        fetchClientAppreciationContextData,
        clientAppreciationContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientAppreciationContext.Provider>
  );
};

export const useClientAppreciationContext = () => useContext(ClientAppreciationContext);
